/* @flow */

import memoize from 'memoize-one';

// Memoizing this function so that we don't create a new function every
// render, which messes up our form.
export const validateForAnyValue = memoize((errorMessage: string) => (value: string) => {
    return value && value.trim().length > 0 ? undefined : errorMessage;
});
